import { Routes, RouterModule, PreloadAllModules  } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import { PagesComponent } from './pages/pages.component';
import { BlankComponent } from './pages/blank/blank.component';
import { SearchComponent } from './pages/search/search.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { ErrorComponent } from './pages/errors/error/error.component';

export const routes: Routes = [
    { 
        path: '', 
        component: PagesComponent, children: [
                { path: '', loadChildren: 'app/pages/dashboard/dashboard.module#DashboardModule', 
                        data: { breadcrumb: 'Dashboard' } },
                { path: 'port-unsecured', loadChildren: 'app/pages/port-unsecured/port-unsecured.module#PortUnsecuredModule', 
                        data: { breadcrumb: 'Retail' } },
                { path: 'secured', loadChildren: 'app/pages/port-secured/port-secured.module#PortSecuredModule', 
                        data: { breadcrumb: 'Secured' } },
                { path: 'port-housing', loadChildren: 'app/pages/port-secured/port-secured.module#PortSecuredModule', 
                        data: { breadcrumb: 'Housing' } },
                { path: 'port-sme-corp', loadChildren: 'app/pages/port-sme-corp/port-sme-corp.module#PortSMECORPModule', 
                        data: { breadcrumb: 'SME-CORP' } },
                // { path: 'port-corp', loadChildren: 'app/pages/port-corp/port-corp.module#PortCorpModule', 
                //         data: { breadcrumb: 'Corporate' } },
                { path: 'ttb', loadChildren: 'app/pages/ttb/ttb.module#TtbModule', 
                        data: { breadcrumb: 'TTB' } },
                { path: 'cheque', loadChildren: 'app/pages/cheque/cheque.module#ChequeModule', 
                        data: { breadcrumb: 'Cheque' } },
                { path: 'credit', loadChildren: 'app/pages/credit/credit.module#CreditModule', 
                        data: { breadcrumb: 'Credit' } },
                { path: 'ibiz', loadChildren: 'app/pages/ibiz/ibiz.module#IbizModule', 
                        data: { breadcrumb: 'IBIZ' } },
                { path: 'tdr', loadChildren: 'app/pages/tdr/tdr.module#TdrModule', 
                        data: { breadcrumb: 'TDR' } },
                { path: 'npa', loadChildren: 'app/pages/npa/npa.module#NpaModule', 
                        data: { breadcrumb: 'NPA' } },
                { path: 'variable', loadChildren: 'app/pages/variable/variable.module#VariableModule', 
                        data: { breadcrumb: 'Variable' } },
                { path: 'collateral', loadChildren: 'app/pages/collateral/collateral.module#CollateralModule', 
                        data: { breadcrumb: 'Collateral' } },
                { path: 'investment', loadChildren: 'app/pages/investment/investment.module#InvestmentModule', 
                        data: { breadcrumb: 'Investment' } },
                { path: 'reports', loadChildren: 'app/pages/reports/reports.module#ReportsModule', 
                        data: { breadcrumb: 'Reports' } },
                { path: 'request', loadChildren: 'app/pages/request/request.module#RequestModule', 
                        data: { breadcrumb: 'Request' } },
                { path: 'approve', loadChildren: 'app/pages/approve/approve.module#ApproveModule', 
                        data: { breadcrumb: 'Approve' } },
                        
                //-- 19-OCT-2021
                { path: 'legal', loadChildren: 'app/pages/legal/legal.module#LegalModule', 
                        data: { breadcrumb: 'Legal' } },

                //-- 14-DEC-2022
                { path: 'application', loadChildren: 'app/pages/application/application.module#ApplicationModule', 
                        data: { breadcrumb: 'Application' } },


                { path: 'users', loadChildren: 'app/pages/users/users.module#UsersModule', 
                        data: { breadcrumb: 'Users' } },
                { path: 'ui', loadChildren: 'app/pages/ui/ui.module#UiModule', 
                        data: { breadcrumb: 'UI' } },
                { path: 'form-controls', 
                        loadChildren: 'app/pages/form-controls/form-controls.module#FormControlsModule', 
                        data: { breadcrumb: 'Form Controls' } },
                { path: 'tables', loadChildren: 'app/pages/tables/tables.module#TablesModule', 
                        data: { breadcrumb: 'Tables' } },
                { path: 'icons', loadChildren: 'app/pages/icons/icons.module#IconsModule', 
                        data: { breadcrumb: 'Material Icons' } },
                { path: 'drag-drop', loadChildren: 'app/pages/drag-drop/drag-drop.module#DragDropModule', 
                        data: { breadcrumb: 'Drag & Drop' } },
                { path: 'schedule', loadChildren: 'app/pages/schedule/schedule.module#ScheduleModule', 
                        data: { breadcrumb: 'Schedule' } },
                { path: 'mailbox', loadChildren: 'app/pages/mailbox/mailbox.module#MailboxModule', 
                        data: { breadcrumb: 'Mailbox' } },
                { path: 'chat', loadChildren: 'app/pages/chat/chat.module#ChatModule', 
                        data: { breadcrumb: 'Chat' } },
                { path: 'maps', loadChildren: 'app/pages/maps/maps.module#MapsModule', 
                        data: { breadcrumb: 'Maps' } },
                { path: 'charts', loadChildren: 'app/pages/charts/charts.module#ChartsModule', 
                        data: { breadcrumb: 'Charts' } },
                { path: 'dynamic-menu', 
                        loadChildren: 'app/pages/dynamic-menu/dynamic-menu.module#DynamicMenuModule', 
                        data: { breadcrumb: 'Dynamic Menu' }  },          
                { path: 'blank', component: BlankComponent, 
                        data: { breadcrumb: 'Blank page' } },
                { path: 'search', component: SearchComponent, 
                        data: { breadcrumb: 'Search' } }
        ]
    },
    //{ path: 'login', loadChildren: 'app/debtor/unsecured/dtunsec-detail/login.module#LoginModule' },
    //{ path: 'dtunsec-details', component: DtunsecDetailComponent, data: { breadcrumb: 'dtunsec-details' } },
    //{ path: 'dtunsec-details/:id/:dt_code',  component: DtunsecDetailComponent },
    //{ path: 'dtunsec-create/:id',   component: DtunsecCreateComponent,
    //{ path: 'landing', loadChildren: 'app/pages/landing/landing.module#LandingModule' },
    { path: 'login', loadChildren: 'app/pages/login/login.module#LoginModule' },
    { path: 'register', loadChildren: 'app/pages/register/register.module#RegisterModule' },
    { path: 'error', component: ErrorComponent, data: { breadcrumb: 'Error' } },
    { path: '**', component: NotFoundComponent }
    
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, {
   //preloadingStrategy: PreloadAllModules,  // <- comment this line for activate lazy load
   // useHash: true
});